import { deskCard, deskMuted, deskPrimaryBtn, deskSecondaryBtn } from "./salesDeskStyles";
import type { SalesDeskLead } from "./salesDeskLead";

export function SalesDeskLeadPanel({
  lead,
  onClose,
  onStart,
}: {
  lead: SalesDeskLead;
  onClose: () => void;
  onStart: () => void;
}) {
  return (
    <div className="fixed inset-0 z-40 grid place-items-center bg-black/40 p-4">
      <section className={`${deskCard} w-full max-w-md`}>
        {lead.source ? (
          <p className="inline-flex rounded-full bg-[#e4edf2] px-2.5 py-1 text-[11px] font-semibold text-[#315d75] dark:bg-zinc-800 dark:text-sky-200">
            {lead.source}
          </p>
        ) : null}
        <h2 className="mt-3 text-[24px] font-semibold tracking-[-0.4px]">{lead.name}</h2>
        <p className={`mt-3 ${deskMuted}`}>{lead.need}</p>
        <div className="mt-6 flex flex-col gap-2">
          <button type="button" onClick={onStart} className={deskPrimaryBtn}>
            Start a sale
          </button>
          <button type="button" onClick={onClose} className={deskSecondaryBtn}>
            Close
          </button>
        </div>
      </section>
    </div>
  );
}
